export interface ChangelogSection {
  title: string
  items: string[]
}

export interface ChangelogRelease {
  version: string
  sections: ChangelogSection[]
}

/**
 * Koľko posledných verzií ukazuje „Čo je nové" (admin aj mobil). CHANGELOG.md
 * si drží celú históriu, používateľom stačia posledné vydania.
 */
export const CHANGELOG_VISIBLE_RELEASES = 3

/**
 * Parsuje CHANGELOG.md v kontrolovanom formáte:
 * `## <verzia>` → release, `### <titulok>` → sekcia, `- <text>` → položka.
 * Všetko ostatné (vrátane `# Changelog` hlavičky) sa ignoruje.
 */
export function parseChangelog(raw: string): ChangelogRelease[] {
  const releases: ChangelogRelease[] = []
  let release: ChangelogRelease | null = null
  let section: ChangelogSection | null = null

  for (const line of raw.split('\n')) {
    const trimmed = line.trim()
    if (trimmed.startsWith('## ')) {
      release = { version: trimmed.slice(3).trim(), sections: [] }
      section = null
      releases.push(release)
    } else if (trimmed.startsWith('### ')) {
      if (!release) continue
      section = { title: trimmed.slice(4).trim(), items: [] }
      release.sections.push(section)
    } else if (trimmed.startsWith('- ')) {
      if (!release) continue
      if (!section) {
        section = { title: '', items: [] }
        release.sections.push(section)
      }
      section.items.push(trimmed.slice(2).trim())
    }
  }
  return releases
}
